import { render, staticRenderFns } from "./ConfigurarDemo.vue?vue&type=template&id=6c8be04d"
import script from "./ConfigurarDemo.vue?vue&type=script&lang=js"
export * from "./ConfigurarDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c8be04d')) {
      api.createRecord('6c8be04d', component.options)
    } else {
      api.reload('6c8be04d', component.options)
    }
    module.hot.accept("./ConfigurarDemo.vue?vue&type=template&id=6c8be04d", function () {
      api.rerender('6c8be04d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/ConfigurarDemo.vue"
export default component.exports